import { css } from 'styled-system/css';

export const valueStyle = css.raw({
  textStyle: 'numbers.small',
  color: 'v2.text.primary',
  textAlign: 'end',
});

export const headLabelStyle = css.raw({
  textStyle: 'v2.meta',
  color: 'v2.text.muted',
  textAlign: 'start',
});

export const headValueStyle = css.raw({
  textStyle: 'numbers.small',
  color: 'v2.text.primary',
  textAlign: 'start',
});
